module.exports = __webpack_public_path__ + "img/emptystate_handsaw.d7674ded.svg";